import {Injectable} from "@angular/core";
import {map} from "rxjs/operators";
import {DataService} from "../shared/data.service";
import {EMPTY, of} from "rxjs";
import {ApiEndpoints} from "../shared/ApiEndpoints";

@Injectable()
export class MeasureService extends DataService{

  getItems() {
    return this.getRequest(ApiEndpoints.measures);
  }

  getItem(id) {
    if (!id) {
      return of({error: 'ID is missing'});
    }
    return this.getRequest(`${ApiEndpoints.measures}/${id}`)
  }

  saveItem(data){
    if (data.id) {
      return this.putRequest(`${ApiEndpoints.measures}`, data);
    } else {
      return this.postRequest(`${ApiEndpoints.measures}`, data);
    }
  }

  deleteItem(id){
    return this.deleteRequest(`${ApiEndpoints.measures}`, id);
  }

}
